import apiClient from '@utils/apiClient';
import {
    WeatherListReq,
    WeatherListRes,
    WeatherAreaListRes,
} from '@/api/weather/weather/type';

export const api = {
    /**
     * 기상데이터 목록
     * @param param
     */
    weatherList: async (param: WeatherListReq): Promise<WeatherListRes> => {
        const response = await apiClient.post<WeatherListRes>(
            '/api/v1/weather/list',
            param,
        );
        return response.data;
    },

    /**
     * 지역코드 조회
     */
    weatherAreaList: async (): Promise<WeatherAreaListRes> => {
        const response = await apiClient.get<WeatherAreaListRes>(
            '/api/v1/weather/area/list',
        );
        return response.data;
    },
};
